import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OnboardingService } from '../../../onboarding.service';
import { SharedService } from '../../../../../shared/shared.service';

@Component({
  selector: 'app-owner-details',
  templateUrl: './owner-details.component.html',
  styleUrl: './owner-details.component.less'
})
export class OwnerDetailsComponent implements OnInit {

  @Input() sponsorOnboardingCMSData: any;
  getGenericLabels: any;
  @Input() ownerDetails: any;
  @Input() partnerAccDetails: any;
  @Output() ownerDataValueChange = new EventEmitter<any>();
  salutationTypeList: any = [];
  commChannelList: any = [];
  isValidEmail: boolean = false;
  validEmailMsg: any = '';
  
  constructor(
    private onboardingService: OnboardingService,
    private sharedService:SharedService
  ) {}

  ngOnInit(): void {
    this.getGenericLabels = JSON.parse(localStorage.getItem('genericLabels') || '{}');
    this.getSalutationList();
    this.getCommunicationCategory();
  }

  getCommunicationCategory() {
    this.onboardingService.getCommunicationCategory().subscribe({
      next: (res: any) => {
        res.forEach((element: any) => {
          let option = { key: element.code, value: element.name };
          this.commChannelList.push(option);
        });
      },
      error: (error: any) => {
        // this.errorMessage = this.offersService.generateBlindError(error);
      },
    });
  }

  getSalutationList() {
    this.sharedService.toggleGlobalLoader(true);
    this.onboardingService.getSalutationList().subscribe({
      next: (res: any) => {
        res.forEach((element: any) => {
          let option = { key: element.code, value: element.name };
          this.salutationTypeList.push(option);
          this.sharedService.toggleGlobalLoader(false);
        });
      },
      error: (error: any) => {
        this.sharedService.toggleGlobalLoader(false);
        // this.errorMessage = this.offersService.generateBlindError(error);
      },
    });
  }

  valueChange(event: any, key: string) {
    switch (key) {
      case 'title':
        this.ownerDetails.title = event;
        break;
      case 'communicationChannel':
        this.ownerDetails.communicationChannel = event;
    }

    this.ownerDataValueChange.emit(this.ownerDetails);
  }

  ownerValueChange(event: any, key: string) {
    switch (key) {
      case 'firstName':
        this.ownerDetails.firstName = event;
        break;
      case 'lastName':
        this.ownerDetails.lastName = event;
      break;
      case 'email':
        this.ownerDetails.email = event;
        this.isValidEmail = true;
        this.validEmailMsg = '';
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        // this.partnerAccDetails.email = event;
        if (!emailPattern.test(this.ownerDetails.email)) {
          this.isValidEmail = false;
          this.validEmailMsg = this.getGenericLabels.EnterValidEmail;
        } else {
          this.isValidEmail = true;
        }
      break;
      case 'phone':
        this.ownerDetails.phone = event;
      break;
      case 'identificationNumber':
        this.ownerDetails.identificationNumber = event;
      break;
      case 'isOwnerPartnerIdenticle':
        this.ownerDetails.isOwnerPartnerIdenticle = event;
        this.ownerDetails.title = this.ownerDetails.isOwnerPartnerIdenticle ? this.partnerAccDetails.title : '';
        this.ownerDetails.firstName = this.ownerDetails.isOwnerPartnerIdenticle ? this.partnerAccDetails.firstName : '';
        this.ownerDetails.lastName = this.ownerDetails.isOwnerPartnerIdenticle ? this.partnerAccDetails.lastName : '';
        this.ownerDetails.email = this.ownerDetails.isOwnerPartnerIdenticle ? this.partnerAccDetails.email : '';
        this.ownerDetails.phone = this.ownerDetails.isOwnerPartnerIdenticle ? this.partnerAccDetails.phone : '';
    }
    this.ownerDataValueChange.emit(this.ownerDetails);
  }

}
